// imports/code in this class should be safe for browser/ui as well as backend/nodeJS consumption

export class LogicUtils {
  static ownersGroupFromPrivGroup(privGroupName: string): string {
    return privGroupName.replace("-escalated", "") + "-owners";
  }
}
